import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@utils/api';
const BagInfoBox = (props) => {
    const { t } = useTranslation();
    const [loaded, setLoaded] = useState(false);
    const [bannerComponents, setBannerComponents] = useState();
    useEffect(() => {
        api.getPageJson('membership-small-banner', true).then((data) => {
            var _a;
            setLoaded(true);
            const currentComponents = (_a = data === null || data === void 0 ? void 0 : data.regions) === null || _a === void 0 ? void 0 : _a[0].components;
            setBannerComponents(currentComponents);
        });
    }, []);
    if (!loaded) {
        return React.createElement(React.Fragment, null);
    }
    if (bannerComponents && bannerComponents.length > 0 && !props.noBanner) {
        return (React.createElement(React.Fragment, null, bannerComponents.map((bannerComponent, index) => (React.createElement("div", { key: index, className: "bag-info-box membership-small-banner" },
            React.createElement("div", { className: "membership-small-banner__image", style: { backgroundImage: `url("${bannerComponent.custom.bg_image}")` } }, bannerComponent.custom.logo && React.createElement("img", { src: bannerComponent.custom.logo, alt: "" })),
            React.createElement("div", { className: "membership-small-banner__content" },
                React.createElement("div", { dangerouslySetInnerHTML: { __html: bannerComponent.data.paragraph } }),
                React.createElement("button", { className: "button-login justify-initial", onClick: props.buttonAction, "aria-haspopup": "dialog", type: "button" },
                    bannerComponent.data.buttonText,
                    React.createElement("span", { className: "icon--chevron-right" }))))))));
    }
    return (React.createElement("div", { className: "bag-info-box" },
        React.createElement("p", null, props.text),
        React.createElement("button", { className: "button-login", onClick: props.buttonAction, "aria-haspopup": "dialog", type: "button" },
            t('checkout.logincta'),
            React.createElement("span", { className: "icon--chevron-right" }))));
};
export default BagInfoBox;
